import { Col, Row } from 'antd';
import { InputComponent } from 'components/common/Input';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const AvailabilityTimesContainerStyled = styled(Col)`
  @media screen and (max-width: ${breakpoints.xl}) {
  }
`;

export const DayTransitionWordContainerStyled = styled(Col)`
  padding: 0 !important;
  min-width: 30px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px !important;
  @media (max-width: ${breakpoints.xl}) {
    margin-bottom: 12px !important;
  }
}
`;

export const TimePickerInputContainerStyled = styled(Col)`
  @media (min-width: 1300px) {
    min-width: 170px;
  }
  @media (max-width: 1299px) {
    min-width: 130px;
  }
  @media (max-width: ${breakpoints.lg}) {
    min-width: 110px;
  }
  @media (max-width: ${breakpoints.sm}) {
    min-width: 120px;
  }
  @media (max-width: ${breakpoints.xs}) {
    min-width: 110px;
  }
  @media (max-width: 350px) {
    min-width: 90px;
  }
`;

export const TimePickerSectionContainerStyled = styled(Col)`
  @media (max-width: ${breakpoints.xs}) {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const WarningMessageContainerStyled = styled(Row)`
  @media and (min-width: ${breakpoints.sm}) {
    height: 36px;
  }
`;

export const TimeZonePickerStyled = styled(InputComponent)`
  margin-bottom: 18px;
  .input-field-container {
    min-width: 180px;
  }
`;
